export const HOME = '/'
export const ANIME_VIEW = '/anime-view'
export const COMICS_INFO = '/comics-info'
export const BUSSOLA_AGIL = '/bussola-agil'
export const SETIME = '/setime'
export const AGENDAMENTO_WEB = '/agendamento-web'
export const PROJETO_VAMOS = '/projeto-vamos'
export const ESCAPE_ROOM_TIMER = '/escape-room-timer'
export const SUPER_POMODORO = '/super-pomodoro'
